/**
 * Represents all JavaScript types as strings.
 * Usefull for "typeof" functions
 */
export default {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    BigInt: 'bigint',
    Symbol: 'symbol',
    Function: 'function',
    Object: 'object',
    Undefined: 'undefined',
};